import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import ModalDialog from '../ModalDialog';
import styles from './confirmButton.module.css';

class ConfirmButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false
    };

    this.onClick = this.onClick.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  onClick() {
    this.setState({ modalOpen: true });
  }

  onConfirm() {
    this.setState({ modalOpen: false });
    this.props.onConfirm();
  }

  onCancel() {
    this.setState({ modalOpen: false });
    this.props.onCancel();
  }

  render() {
    const {
      children, className, modalText, modalTitle, title, dataCy
    } = this.props;
    const buttonClass = className || `button--action ${styles.button}`;

    return (
      <div className={styles.container}>
        <button
          type="button"
          className={buttonClass}
          onClick={this.onClick}
          title={title}
          data-cy={dataCy}
        >
          {children}
        </button>
        <ModalDialog
          isOpen={this.state.modalOpen}
          onCancel={this.onCancel}
          onConfirm={this.onConfirm}
        >
          {modalTitle && <h4>{modalTitle}</h4>}
          {modalText}
        </ModalDialog>
      </div>
    );
  }
}

const { string, func, node } = PropTypes;
ConfirmButton.propTypes = {
  className: string,
  title: string,
  children: node,
  modalTitle: string,
  modalText: string.isRequired,
  onConfirm: func.isRequired,
  onCancel: func,
  dataCy: string
};

ConfirmButton.defaultProps = {
  onCancel: noop,
  className: undefined,
  modalTitle: '',
  title: undefined,
  children: undefined,
  dataCy: ''
};

export default ConfirmButton;
